import Dialog from "@mui/material/Dialog";
import TitreDialog from "./TitreDialog";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { Link } from "react-router";
export default function PaperDialog({
	titre,
	children,
	actions,
	submitStatus,
	...props
}) {
	return (
		<Dialog
			open={true}
			component={"form"}
			fullWidth
			scroll="paper"
			maxWidth="xl"
			slotProps={{
				container: { sx: { alignItems: "flex-start", mt: 13, pb: 13 } },
			}}
			{...props}
		>
			<TitreDialog titre={titre ? titre : "Titre manquant ..."} />
			<DialogContent>{children}</DialogContent>
			<DialogActions sx={{ justifyContent: "space-between", mx: 3 }}>
				{actions ? (
					actions
				) : (
					<>
						<Link to="..">
							<Button
								color="error"
								variant="contained"
							>
								{submitStatus ? "Fermer" : "Annuler"}
							</Button>
						</Link>
						{!submitStatus && (
							<Button
								color="success"
								variant="contained"
								type="submit"
							>
								Valider
							</Button>
						)}
					</>
				)}
			</DialogActions>
		</Dialog>
	);
}
